import { addDays } from "date-fns/esm";

import { getWeekStart } from "@app/util/dates";

const getSampleChartData = (): Array<{ date: Date; value: number }> => {
  const weekStart = getWeekStart(Date.now());
  const tableData = [90, 180, 200, 280, 190, 220, 0];
  return Array.from({ length: 7 }, (_, index) => {
    const date = addDays(weekStart, index);
    return {
      date,
      value: tableData[date.getDay()],
    };
  });
};

export default getSampleChartData;
